import React from 'react'
import { Col, Input } from 'antd'
import * as UI from 'konsys-ui'
import { detailMode } from '../constants'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Radio box
5: Upload box
6: Button
*/

const CreateMode = ({ data, onChangeHandler }) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span}>
          <UI.InputWithLabel {...data.props} width='100%' input={{
            disabled: data.props.disabled,
            onChange: e => onChangeHandler(data.id, e.target.value),
          }} />
        </Col>
      )
    case 1:
      return (
        <Col span={data.span}>
          <UI.P margin='0 0 8px 0'>{data.label}</UI.P>
          <Input.TextArea rows={4} style={{ margin: '0 0 16px' }} onChange={e => onChangeHandler(data.id, e.target.value)}/>
        </Col>
      )
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, disabled, initialData, onChangeHandler,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span}>
          <UI.InputWithLabel width='100%' {...data.props} input={{
            disabled: disabled || data.props.disabled,
            defaultValue: initialData[data.id],
            onChange: e => onChangeHandler(data.id, e.target.value),
          }} />
        </Col>
      )
    case 1:
      return (
        <Col span={data.span}>
          <UI.P margin='0 0 8px 0'>{data.label}</UI.P>
          <Input.TextArea defaultValue={initialData[data.id]} disabled={disabled} rows={4} style={{ margin: '0 0 16px' }} onChange={e => onChangeHandler(data.id, e.target.value)}/>
        </Col>
      )
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, mutationVariables,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.EDIT:
      return <EditMode data={data} mutationVariables={mutationVariables} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.VIEW:
      return <EditMode data={data} disabled={true} mutationVariables={mutationVariables} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    default:
      return <p>no mode</p>
  }
}
